import { useGiftQuery } from '../queries/useGiftQuery'
import { useOrderGroupedByShipmentsQuery } from '../queries/useOrderGroupedByShipmentsQuery'
import { useOrderBanners } from './useOrderBanners'
import { useOrderIdParam } from './useOrderIdParam'

export const useOrder = () => {
  const { orderId } = useOrderIdParam()
  const { orderGroupedByShipmentsQuery } = useOrderGroupedByShipmentsQuery([{ orderId }])
  const { giftQuery } = useGiftQuery([{ giftId: orderGroupedByShipmentsQuery.data?.giftId! }], {
    enabled: !!orderGroupedByShipmentsQuery.data?.giftId,
  })
  const { banners } = useOrderBanners()

  const shippingMethodTooltip = (() => {
    if (
      orderGroupedByShipmentsQuery.data &&
      orderGroupedByShipmentsQuery.data.type === 'GIFT' &&
      giftQuery.data &&
      giftQuery.data.giveawayId
    ) {
      return 'Average shipping costs for purchased gifts are included in the product price.'
    }
  })()

  return {
    orderId,
    banners,
    shippingMethodTooltip,
    order: orderGroupedByShipmentsQuery.data,
    isLoading: orderGroupedByShipmentsQuery.isLoading,
    isUnavailable:
      orderGroupedByShipmentsQuery.isError ||
      (orderGroupedByShipmentsQuery.isSuccess &&
        orderGroupedByShipmentsQuery.data.status === 'OPEN'),
  }
}
